// extracted by mini-css-extract-plugin
export default {"combinedShieldRoot":"combinedShieldRoot___Gg79b","chef":"chef___qs8vJ","s":"s___jmp9V","m":"m___N3D_U","l":"l___aPNGv","combinedShieldImg":"combinedShieldImg___xvCqP"};